import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Form, Select } from 'antd';

import { ACTION_PLAN_DATE_STATUS } from '@/util/enum';

export const DeadlineStatus: React.FC = () => {
	return (
		<Col xs={24}>
			<Form.Item name={['deadline_status']} label={I18n.get('Status')} labelCol={{ span: 24 }}>
				<Select
					allowClear
					showSearch
					style={{ width: '100%' }}
					placeholder={I18n.get('Select an option')}
					optionFilterProp="children"
				>
					{ACTION_PLAN_DATE_STATUS.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{I18n.get(option.description)}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
		</Col>
	);
};
